import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Feedback from "@/pages/Feedback";
import About from "@/pages/About";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tjenester" element={<Services />} />
      <Route path="/tjenester/:slug" element={<ServiceDetail />} />
      <Route path="/prosjekter" element={<Projects />} />
      <Route path="/prosjekter/:id" element={<ProjectDetail />} />
      <Route path="/om-oss" element={<About />} />
      <Route path="/be-om-pristilbud" element={<Quote />} />
      <Route path="/kontakt" element={<Contact />} />
      <Route path="/personvern" element={<Privacy />} />
      <Route path="/tilbakemelding-skjema/:token" element={<Feedback />} />
      <Route path="/tilbakemelding/:token" element={<Feedback />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </LanguageProvider>
  );
}
